import { useState, useEffect } from "react";
import styles from "./SimpleTableCard.module.scss";

const INITIAL_VISIBLE = 15;

const SimpleTableCard = ({
	columns = [],
	data = [],
	rowKey = "id",
	loading = false,
	loadingMessage = "Cargando datos...",
	emptyMessage = "Sin registros",
	toolbar = null,
	rowClassName,
	extraLoading = false,
	extraLoadingMessage = "Cargando...",
}) => {
	const colSpan = columns.length;
	const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);

	useEffect(() => {
		setVisibleCount(INITIAL_VISIBLE);
	}, [data]);

	const visibleRows = data.slice(0, visibleCount);
	const hasMore = data.length > visibleCount;

	return (
		<div className={styles.card}>
			{toolbar && <div className={styles.toolbar}>{toolbar}</div>}
			<div className={styles.tableWrap}>
				{loading ? (
					<div className={styles.loadingState}>{loadingMessage}</div>
				) : (
					<table className={styles.table}>
						<thead>
							<tr>
								{columns.map((column) => {
									const headerStyle = {};
									if (column.width) headerStyle.width = column.width;
									if (column.align) headerStyle.textAlign = column.align;
									return (
										<th key={column.key} style={Object.keys(headerStyle).length ? headerStyle : undefined}>
											{column.label}
										</th>
									);
								})}
							</tr>
						</thead>
						<tbody>
							{data.length === 0 ? (
								<tr>
									<td colSpan={colSpan} className={styles.emptyCell}>
										{emptyMessage}
									</td>
								</tr>
							) : (
								<>
									{visibleRows.map((row) => (
										<tr key={row[rowKey]} className={rowClassName ? rowClassName(row) : ""}>
											{columns.map((column) => (
												<td key={column.key} style={column.align ? { textAlign: column.align } : undefined}>
													{column.render ? column.render(row[column.key], row) : row[column.key]}
												</td>
											))}
										</tr>
									))}
									{extraLoading && (
										<tr>
											<td colSpan={colSpan}>
												<div className={styles.loadingState}>{extraLoadingMessage}</div>
											</td>
										</tr>
									)}
								</>
							)}
						</tbody>
					</table>
				)}
			</div>
			{!loading && hasMore && (
				<div className={styles.loadMore}>
					<button type="button" className={styles.loadMoreButton} onClick={() => setVisibleCount((prev) => prev + INITIAL_VISIBLE)}>
						Cargar más ({data.length - visibleCount} restantes)
					</button>
				</div>
			)}
		</div>
	);
};

export default SimpleTableCard;
